import { Navigate } from "react-router";

import { EuropeanCountryCodes, TaxRates } from './configData';
import { getTiers } from '../api/tiers';



const Roles = {
    admin: ['main', 'admin', 'settings', 'logout'],
    manager: ['main', 'admin', 'settings', 'logout'],
    client: ['main', 'logout'],
}

const checkRole = (url) => {

    const role = localStorage.getItem('role')
    url = url.split('/')[1]
    if (!Roles[role].includes(url)) {
        return Navigate({ to: '/' })
    }
}


const creat_id = () => {
    return new Date().getTime().toString(16) + Math.random().toString(16).slice(2)
}


const generateId = () => {
    const timestamp = (new Date().getTime() / 1000 | 0).toString(16);
    let l = 'xxxxxxxxxxxxxxxx'

    let oid = timestamp + l
        .replace(/[x]/g, _ => (Math.random() * 16 | 0).toString(16))
        .toLowerCase();
    return oid;
}



function focusNextInput() {
    const focusableElements = Array.from(
        document.querySelectorAll('input, select, textarea, button, [tabindex]:not([tabindex="-1"])')
    ).filter(el => !el.disabled && el.tabIndex >= 0);

    const currentIndex = focusableElements.indexOf(document.activeElement);
    const next = focusableElements[currentIndex + 1];

    if (next) {
        next.focus();
    }
}


const complitePadStart = (num, places, badBy) => { return String(num).padStart(places, badBy) }
const complitePadEnd = (num, places, badBy) => { return String(num).padEnd(places, badBy) }


function generateCodeString(str) {
    return str
        .toLowerCase()                // строчные буквы
        .normalize("NFD")             // удаление диакритических знаков (é → e)
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9\s]/g, "")  // удаление спецсимволов, кроме пробелов
        .trim()
        .replace(/\s+/g, "_");        // замена пробелов на "_"
}


const ganerateCodeTier = async (dataTier) => {

    const rg = /[a-zA-Z0-9]+/g;

    let vname = complitePadEnd(dataTier.name.match(rg).join('').slice(0, 5).toUpperCase(), 5, 'X');
    let vzipCode = complitePadEnd(dataTier.zipCode.slice(0, 2), 2, 'X') || 'XX';
    let vcity = complitePadEnd(dataTier.city.slice(0, 3).toUpperCase(), 3, 'X') || 'XXX';
    let vcountryCode = dataTier.countryCode.toUpperCase()

    let code = vname + vcountryCode + vzipCode + vcity
    code = vname + vzipCode + vcity

    const rs = await getTiers({ code });
    if (rs && rs.length > 0) {
        const idex = rs.map(i => i.code);

        if (idex.length === 1) {
            return `${code}01`;
        } else {
            let maxIndex = []
            for (let j of idex) {
                j = j.slice(10)
                if (j) {
                    maxIndex.push(parseInt(j, 10));
                }
            }
            maxIndex =  Math.max(...maxIndex);
            const newCode = `${code}${complitePadStart(maxIndex + 1, 2, '0')}`;
            console.log('Duplicate found, returning new code:', newCode);
            return newCode;
        }
    }
  
    return code
}

function determineVatRate({
    providerCountry = 'FR',
    orderingParty,
    consignor,
    consignee,
}) {
    const clientCountry = orderingParty.countryCode;
    const departureCountry = consignor.countryCode;
    const arrivalCountry = consignee.countryCode;

    const isProviderInEU = EuropeanCountryCodes.includes(providerCountry);
    const isClientInEU = EuropeanCountryCodes.includes(clientCountry);
    const isDepartureInEU = EuropeanCountryCodes.includes(departureCountry);
    const isArrivalInEU = EuropeanCountryCodes.includes(arrivalCountry);

    const isNationalTransport =
        departureCountry === arrivalCountry &&
        clientCountry === providerCountry &&
        clientCountry === departureCountry;

    const isIntraEU = isDepartureInEU && isArrivalInEU;
    const isInternational = !isDepartureInEU || !isArrivalInEU;

    const taxRates = TaxRates.reduce((acc, rate) => {
        acc[rate.key] = rate;
        return acc;
    }, {});

    // CAS 1 : client hors UE → HT, TVA non applicable
    if (!isClientInEU) {
        return {
            vatKey: 'tax_0',
            vatRate: taxRates['tax_0'],
            reasonCode: "CLIENT_OUTSIDE_EU",
            reason: {
                fr: "Client établi hors UE – TVA non applicable (article 44 de la directive 2006/112/CE)",
                en: "Client established outside the EU – VAT not applicable (Article 44 of Directive 2006/112/EC)"
            }
        };
    }

    // CAS 2 : client et prestataire dans le même pays
    if (clientCountry === providerCountry) {
        // 2.1 Transport national
        if (isNationalTransport) {
            return {
                vatKey: 'tax_20', // à adapter au pays
                vatRate: taxRates['tax_20'],
                reasonCode: "DOMESTIC_TRANSPORT",
                reason: {
                    fr: "Transport national – TVA locale applicable",
                    en: "Domestic transport – Local VAT applies"
                }
            };
        }

        // 2.2 Transport international depuis/vers pays tiers
        if (isInternational) {
            return {
                vatKey: 'tax_0',
                vatRate: taxRates['tax_0'],
                reasonCode: "EXPORT_OR_IMPORT",
                reason: {
                    fr: "Exportation ou importation – Exonération de TVA (article 146 de la directive 2006/112/CE ou équivalent local)",
                    en: "Export or import – VAT exemption (Article 146 of Directive 2006/112/EC or local equivalent)"
                }
            };
        }

        // 2.3 Transport intra-UE
        return {
            vatKey: 'tax_20',
            vatRate: taxRates['tax_20'],
            reasonCode: "INTRA_EU_SAME_COUNTRY",
            reason: {
                fr: "Client dans le même pays que le prestataire – TVA locale due",
                en: "Client in same country as provider – Local VAT applies"
            }
        };
    }

    // CAS 3 : client UE ≠ prestataire UE → autoliquidation
    if (isClientInEU && isProviderInEU && clientCountry !== providerCountry) {
        return {
            vatKey: 'tax_0',
            vatRate: taxRates['tax_0'],
            reasonCode: "INTRA_EU_REVERSE_CHARGE",
            reason: {
                fr: "Client établi dans un autre pays de l'UE – Autoliquidation de la TVA (articles 44 & 196 de la directive 2006/112/CE)",
                en: "Client established in another EU country – Reverse charge applies (Articles 44 & 196 of Directive 2006/112/EC)"
            }
        };
    }

    // CAS 4 : prestataire hors UE, client dans l’UE
    if (!isProviderInEU && isClientInEU) {
        return {
            vatKey: 'tax_0',
            vatRate: taxRates['tax_0'],
            reasonCode: "PROVIDER_OUTSIDE_EU",
            reason: {
                fr: "Prestataire établi hors UE – TVA à autoliquider par le client dans son pays",
                en: "Provider established outside the EU – Reverse charge by client in their country"
            }
        };
    }

    // CAS 5 : fallback par défaut (hors champ)
    return {
        vatKey: 'tax_0',
        vatRate: taxRates['tax_0'],
        reasonCode: "UNDEFINED_CASE",
        reason: {
            fr: "Cas non standard – TVA non applicable (hors champ)",
            en: "Non-standard case – VAT not applicable (out of scope)"
        }
    };
}


let cl = {
    "_id": "686508eba413e5e9c85cec6e",
    "address": "KRASNOGORSKY DISTRICT",
    "city": "ALMATY",
    "code": {},
    "contacts": [],
    "country": "Kazakhstan",
    "countryCode": "KZ",
    "created_at": "2025-07-02T10:25:56",
    "created_by": "MELTONIAN Goga",
    "isCarrier": false,
    "isClient": true,
    "isFournisseur": false,
    "isSubcontractor": false,
    "memo": "",
    "name": "REZNIKOVICH LEONID",
    "siret": "",
    "tva": "",
    "updated_at": "2025-07-02T10:25:56",
    "updated_by": "MELTONIAN Goga",
    "zipCode": "X"
}



export { checkRole, creat_id, generateId, focusNextInput, complitePadStart, complitePadEnd, ganerateCodeTier, determineVatRate, generateCodeString };
